import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InboxIcon from "@mui/icons-material/Inbox";

interface EmptyStateProps {
  minHeight?: string;
  icon?: ReactNode;
  title?: string;
  description?: string;
}

export const EmptyState: FC<EmptyStateProps> = ({
  minHeight = "400px",
  icon,
  title,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight,
        gap: "15px",
      }}
    >
      {icon ?? <InboxIcon sx={{ fontSize: "4rem", color: "#ccc" }} />}
      <Typography variant="h5" sx={{ color: "#666" }}>
        {title ?? t("empty_state.title")}
      </Typography>
      {(description !== undefined || !title) && (
        <Typography variant="body1" sx={{ color: "#999" }}>
          {description ?? t("empty_state.description")}
        </Typography>
      )}
    </Box>
  );
};

export default EmptyState;
